import { Link } from '@/components/ui'
import type { CaseDocument } from '@/modules/tools/bankruptcy/stores/types'

export const DocumentLink = ({ document }: { document: CaseDocument }) => {
  return (
    <>
      {document.fileUrl ? (
        <Link
          href={document.fileUrl}
          newTab
          className="inline truncate font-medium text-sm"
        >
          {document.fileName ?? 'Document'}
        </Link>
      ) : (
        <span className="truncate font-medium text-sm">
          {document.fileName ?? 'Document'}
        </span>
      )}
    </>
  )
}
